import { Api } from "../utils";

const BackgroundActions = {

  async getBackgroundImage() {
    const url = `services/app/Configuration/GetBackgroundImage`;
    try {
      const response = await Api.fetchAsync(url);
      Api.validateResponse(response, url);
      const { result } = await response.json();
      return result;
    } catch (e) {
      return null;
    }
  },
};

export default BackgroundActions;